import React from 'react'
import raf from 'raf'
import PropTypes from 'prop-types'

import PlayIcon from '../icons/play'
import PauseIcon from '../icons/pause'
import SpinnerIcon from '../icons/spinner'

import styles from './audioPlayerSmall.module.css'

export default class AudioPlayerSmall extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    onPlay: PropTypes.func,
    isActive: PropTypes.bool
  }

  static defaultProps = {
    onPlay: () => {}
  }

  constructor (props) {
    super(props)

    this.state = {
      playing: false,
      loading: false,
      playBarProgress: 0,
      playPromise: null
    }

    this.togglePlay = this.togglePlay.bind(this)
    this.onPlay = this.onPlay.bind(this)
    this.onPause = this.onPause.bind(this)
    this.audioCanPlay = this.audioCanPlay.bind(this)
    this.onAudioProgress = this.onAudioProgress.bind(this)
    this.setAudioElementRef = this.setAudioElementRef.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (this.audioElement) {
      if (prevProps.isActive && !this.props.isActive) {
        this.tryPause()
      }
    }
  }

  onPause () {
    this.setState({ playing: false })
  }

  onPlay () {
    this.props.onPlay()
    this.setState({ playing: true })
    raf(this.onAudioProgress)
  }

  tryPause () {
    if (this.state.playPromise && this.audioElement) {
      this.state.playPromise.then(() => {
        this.audioElement.pause()
      })
    }
  }

  tryPlay () {
    if (this.audioElement) {
      /*
       For some old browsers (Safari 9) play() does not return promise but undefined.
       Let's handle that case by returning resolved promise instead.
       */
      return this.audioElement.play() || Promise.resolve()
    }
  }

  togglePlay () {
    const { playing } = this.state
    if (this.audioElement) {
      const isTrulyPlaying = this.audioElement.currentTime > 0 &&
        !this.audioElement.paused &&
        !this.audioElement.ended &&
        this.audioElement.readyState > 2
      if (playing && isTrulyPlaying) {
        this.tryPause()
      } else if (!isTrulyPlaying) {
        this.setState({
          playPromise: this.tryPlay()
        })
        this.showLoading()
      }
    }
  }

  onAudioProgress () {
    if (this.state.playing) {
      if (this.audioElement) {
        this.setState({ playBarProgress: this.audioElement.currentTime / this.audioElement.duration })
      }
      raf(this.onAudioProgress)
    }
  }

  showLoading () {
    if (this.audioElement.seeking || this.audioElement.readyState < 3) {
      this.setState({ loading: true })
    } else {
      this.setState({ loading: false })
    }
  }

  audioCanPlay () {
    this.showLoading()
  }

  setAudioElementRef (audioElement) {
    this.audioElement = audioElement
  }

  render () {
    const { src } = this.props
    const { playing, loading, playBarProgress } = this.state

    let buttonIcon = null
    if (loading) {
      buttonIcon = <SpinnerIcon className={styles.spinningIcon} />
    } else {
      if (playing) {
        buttonIcon = <PauseIcon className={styles.whiteIcon} />
      } else {
        buttonIcon = <PlayIcon className={styles.icon} />
      }
    }

    return (
      <div className={styles.container}>
        <audio
          ref={this.setAudioElementRef}
          preload='none'
          onPlay={this.onPlay}
          onPause={this.onPause}
          onCanPlay={this.audioCanPlay}
        >
          <source src={src} type='audio/mpeg' />
        </audio>
        <button onClick={this.togglePlay} className={styles.playButton}>
          {buttonIcon}
        </button>
        <div className={styles.progressBarContainer}>
          <div className={styles.progressBar} style={{
            width: `${playBarProgress * 100}%`
          }} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/audio/audioPlayerSmall.js